import { render, staticRenderFns } from "./tableDaftarRiwayat.vue?vue&type=template&id=5a7f1d3a&scoped=true"
import script from "./tableDaftarRiwayat.vue?vue&type=script&lang=js"
export * from "./tableDaftarRiwayat.vue?vue&type=script&lang=js"
import style0 from "./tableDaftarRiwayat.vue?vue&type=style&index=0&id=5a7f1d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f1d3a",
  null
  
)

export default component.exports